import { StaffType } from 'types/staff'
import { FirebaseDocRefType } from 'firebase/index'
import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { closeStaffModalAction } from 'reducks/modal/actions'
import { fetchStaffsAction } from 'reducks/staff/actions'
import { fetchEventRefs, replaceStaffInList } from 'reducks/staff/operations'
import { REMOVE_STAFF_FROM_STORE_ENDPOINT } from 'constants/urls'
import { fetchStaff, postStaffApi, toStaffApiErrorMessage } from 'repos/staff'

// メンバーを店舗から外す。権限・メール受信設定・招待の有効期限の削除は Functions 側で行う
const removeStaffFromStore = (staff: StaffType, storeRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    dispatch(showLoadingAction())
    try {
      await postStaffApi(REMOVE_STAFF_FROM_STORE_ENDPOINT, { staff_uid: staff.uid, store_id: storeRef.id })
      const [nextStaff, eventRefs] = await Promise.all([fetchStaff(staff.uid), fetchEventRefs()])
      const { staff: staffState, auth } = getState()
      dispatch(
        fetchStaffsAction(
          replaceStaffInList(staffState.staffs, staff.uid, nextStaff, auth.switching_store_refs, eventRefs)
        )
      )
    } catch (error) {
      console.error(error)
      alert(toStaffApiErrorMessage(error, 'メンバーの削除に失敗しました。'))
    } finally {
      dispatch(hideLoadingAction())
      dispatch(closeStaffModalAction())
    }
  }
}

export default removeStaffFromStore
